var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66669 5.33333V9.19999C2.66669 10.8802 2.66669 11.7202 2.99367 12.362C3.28129 12.9265 3.74023 13.3854 4.30472 13.673C4.94645 14 5.78653 14 7.46669 14H8.53335C10.2135 14 11.0536 14 11.6953 13.673C12.2598 13.3854 12.7188 12.9265 13.0064 12.362C13.3334 11.7202 13.3334 10.8802 13.3334 9.2V5.33333",
    stroke: "#02698C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66665 8.66667H9.33331M2.99998 2H13C13.3097 2 13.4646 2 13.5934 2.02562C14.1224 2.13083 14.5358 2.54429 14.641 3.07321C14.6666 3.20201 14.6666 3.3569 14.6666 3.66667C14.6666 3.97644 14.6666 4.13132 14.641 4.26012C14.5358 4.78904 14.1224 5.2025 13.5934 5.30771C13.4646 5.33333 13.3097 5.33333 13 5.33333H2.99998C2.69021 5.33333 2.53532 5.33333 2.40653 5.30771C1.87761 5.2025 1.46414 4.78904 1.35893 4.26012C1.33331 4.13132 1.33331 3.97644 1.33331 3.66667C1.33331 3.3569 1.33331 3.20201 1.35893 3.07321C1.46414 2.54429 1.87761 2.13083 2.40653 2.02562C2.53532 2 2.69021 2 2.99998 2Z",
    stroke: "#02698C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchive);
export default __webpack_public_path__ + "static/media/IconArchive.8a4fcd3f365ad61b852d903a5c91d473.svg";
export { ForwardRef as ReactComponent };